import React from 'react';
import JavascriptBomWindow from './JavascriptBomWindow.jsx';
import JavascriptBomScreen from './JavascriptBomScreen.jsx';
import JavascriptBomLocation from './JavascriptBomLocation.jsx';
import JavascriptBomHistory from './JavascriptBomHistory.jsx';
import JavascriptBomNavigator from './JavascriptBomNavigator.jsx';
import JavascriptBomPopupAlert from './JavascriptBomPopupAlert.jsx';
import JavascriptBomTiming from './JavascriptBomTiming.jsx';
import JavascriptBomCookies from './JavascriptBomCookies.jsx';

export default function JsBrowserBom() {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold">JS Browser BOM</h1>
      <ul className="mt-4 list-disc ml-6">
        <li><a href='/javascript/bom/window' className='underline'>JS Window</a></li>
<li><a href='/javascript/bom/screen' className='underline'>JS Screen</a></li>
<li><a href='/javascript/bom/location' className='underline'>JS Location</a></li>
<li><a href='/javascript/bom/history' className='underline'>JS History</a></li>
<li><a href='/javascript/bom/navigator' className='underline'>JS Navigator</a></li>
<li><a href='/javascript/bom/popup-alert' className='underline'>JS Popup Alert</a></li>
<li><a href='/javascript/bom/timing' className='underline'>JS Timing</a></li>
<li><a href='/javascript/bom/cookies' className='underline'>JS Cookies</a></li>
      </ul>
    </div>
  );
}
